import { useContext, useEffect } from 'react'

import { ParamsRecap } from '@/containers/cestovko/ParamsRecap'
import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { MainContent } from '../../../components/MainContent'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Recap } from '../../../containers/cestovko/Recap'
import { WithOffer } from '../../../containers/hoc/WithOffer'
import { InsuranceInfo } from '../../../containers/InsuranceInfo/InsuranceInfo'
import { MeetingRecordFormTravel } from '../../../containers/MeetingRecordFormTravel'
import { StepsContent } from '../../../context/StepsContext'
import { useGetMeetingRecord } from '../../../hooks/useWizard'
import { insuranceParamsContext } from '../../../layouts/Wizard'
import { meetingRecordContext } from '../../carkulka/wizard/5'
import { CompletedPage } from './completed'

export const Step5Component = () => {
  const { insuranceParams, insuranceParamsId, isLoadingData } = useContext(insuranceParamsContext)
  const { isLoading, isFetching, data, refetch } = useGetMeetingRecord(insuranceParamsId!, { enabled: false, gcTime: 0 })
  const isContracted = !!insuranceParams?.generalParams.contractNumber

  // vynuceni nacteni dat
  useEffect(() => {
    if (insuranceParamsId) {
      refetch()
    }
  }, [insuranceParamsId])

  return (
    <Section>
      <Container>
        <meetingRecordContext.Provider
          value={{
            isLoading: isFetching || isLoading,
            refetch: refetch,
            meetingRecord: data?.data
          }}>

          {isLoadingData && <Loading large={true} />}

          {!isContracted && !!insuranceParams &&
            <StepsContent step={5} >
              <Steps icon="beach" />

              <InsuranceInfo />

              <MainContent>
                <ParamsRecap />

                <Recap />

                <MeetingRecordFormTravel />
              </MainContent>

            </StepsContent>
          }

          {isContracted && !!insuranceParams && <CompletedPage />}
        </meetingRecordContext.Provider>

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step5 = WithOffer(Step5Component)